import type { TBadgeMap } from '@lib/types/ui/TBadgeStyle';

export enum ChannelEnum {
  Unknown = 0,
  DirectMail = 1,
  Internet = 2,
  Television = 3,
  Ecommerce = 4,
}

export const ChannelEnumDisplayName = {
  [ChannelEnum.Unknown]: 'Unknown',
  [ChannelEnum.DirectMail]: 'Direct Mail',
  [ChannelEnum.Internet]: 'Internet',
  [ChannelEnum.Television]: 'Television',
  [ChannelEnum.Ecommerce]: 'Ecommerce',
} satisfies Record<ChannelEnum, string>;

export const ChannelBadgeMap: TBadgeMap<ChannelEnum> = {
  [ChannelEnum.Unknown]: {
    label: ChannelEnumDisplayName[ChannelEnum.Unknown],
    color: 'warn',
  },
  [ChannelEnum.Internet]: {
    label: ChannelEnumDisplayName[ChannelEnum.Internet],
    color: 'warn',
  },
  [ChannelEnum.Television]: {
    label: ChannelEnumDisplayName[ChannelEnum.Television],
    color: 'warn',
  },
  [ChannelEnum.DirectMail]: {
    label: ChannelEnumDisplayName[ChannelEnum.DirectMail],
    color: 'warn',
  },
  [ChannelEnum.Ecommerce]: {
    label: ChannelEnumDisplayName[ChannelEnum.Ecommerce],
    color: 'warn',
  },
};
